/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import { ListGroup } from "react-bootstrap";
import requireAuth from "components/hoc/requireAuth";
import { setCompany, getCompanies, getProfileGeneral } from "actions";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { Trans } from "react-i18next";
import i18n from "i18next";
import Helpers from "util/helpers";

class SwitchCompany extends Component {
  state = {
    companies: [],
    filteredCompanies: [],
  };

  componentDidMount() {
    this.fetchCompaniesData();
  }

  fetchCompaniesData = () => {
    this.props.getCompanies(
      this.onBegin,
      this.onFetchCompaniesSuccess,
      this.onError
    );
  };
  onBegin = () => {
    this.props.onProcessBegin();
  };
  onError = (err) => {
    this.props.onProcessEnd();
    console.log(err);
  };
  onFetchCompaniesSuccess = (res) => {
    this.props.onProcessEnd();
    this.setState({
      companies: res.data.companies,
      filteredCompanies: res.data.companies,
    });
  };

  handleSwitchCompany = (companyId) => {
    this.props.setCompany(
      companyId,
      this.onBegin,
      this.onSetCompanySuccess,
      this.onError
    );
  };

  onSetCompanySuccess = (res) => {
    this.props.onProcessEnd();

    this.props.getProfileGeneral(
      this.onBegin,
      this.onProfileSuccess,
      this.onError
    );
  };

  onProfileSuccess = () => {
    this.props.onProcessEnd();
    localStorage.setItem("roles", this.props.generalProfile.roles);
    window.location.replace(`${window.location.origin}/profile#company`);
  };

  handleCompanyFilter = (e) => {
    this.setState({
      filteredCompanies: this.state.companies.filter((item) => {
        return Helpers.getTurkishCharaterFixedList(item.name).includes(
          Helpers.getTurkishCharaterFixedList(e.currentTarget.value)
        );
      }),
    });
  };

  render() {
    return (
      <div className="row">
        {this.props.spinner}
        <div className="col-sm-6">
          <h4>
            <Trans desc="Bayi">10565</Trans> :{" "}
            {this.props.generalProfile.companyName}
          </h4>

          <div className="inner-addon right-addon">
            <span className="iconmford fo-icon-search"></span>
            <input
              type="text"
              className="form-control"
              placeholder={i18n.t("10053")}
              onChange={(e) => this.handleCompanyFilter(e)}
            />
          </div>
          <ListGroup
            className="mt-3"
            style={{ maxHeight: "400px", overflowY: "scroll" }}
          >
            {this.state.filteredCompanies.map((item) => (
              <ListGroup.Item key={item.id}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span
                    style={{ fontWeight: item.mainDealer ? "bold" : "normal" }}
                  >
                    {item.name}
                  </span>
                  <button
                    type="button"
                    className="btn-sm btn btn-kaydet"
                    onClick={() => this.handleSwitchCompany(item.id)}
                  >
                    <Trans desc="Geçiş Yap">10597</Trans>
                  </button>
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    generalProfile: state.profile.general,
  };
};

export default connect(mapStateToProps, {
  getCompanies,
  setCompany,
  getProfileGeneral,
})(requireAuth(containsLongRunningProcess(SwitchCompany)));
